export const environment = {
	production: false,
	environment: 'qa',

	apsUrl: 'https://wwwedu.accessmgmt.ford.com',

	redirect: 'https://wwwqa.vector.ford.com/home',
	endpoint: 'https://wwwqa.vector.ford.com',

	msalConfig: {
		auth: {
			clientId: 'adad3192-d975-4ddf-a9e4-9d837fc1a5b7',
			authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
		},
		redirectUri: 'https://wwwqa.vector.ford.com/home',
		postLogoutRedirectUri: 'https://wwwqa.vector.ford.com',
	},
	apiConfig: {
		scopes: ['user.read'],
		uri: 'https://graph.microsoft.com/v1.0/me',
	},
	vectorBffConfig: {
		scopes: ['api://f9244829-924a-4aa8-8551-55f4cf12bebc/vector-webapp'],
		uri: 'https://api-qat.mss.ford.com/vector/bff'
	}
};
